/* global mw_glossary_ajax_object */

$(document).on("click", 'body .m__glossary .m__glossary__letter__item', function(e) { 
    $('.m__glossary #loading').addClass('active');
    $('.m__glossary .loading-background').addClass('active');
    var letter = $(this).attr('data-letter');
    $('.m__glossary .m__glossary__letter__item').removeClass('active');
    $(this).addClass('active');
    console.log(letter);
    e.preventDefault(); 

    var ajaxPromise = $.ajax({
        type: 'POST',
        url: mw_glossary_ajax_object.ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_glossary',
            'letter': letter,
            'security': mw_glossary_ajax_object.nonce,
        }),
        success: function (data) {
            result = data.html; 
        }
    });
    $.when(ajaxPromise).done(function () {
        $('.m__glossary__wrapper__contain').html(result);
        $('#loading').removeClass('active'); 
        $('.m__glossary .loading-background').removeClass('active');
    });
});

$(document).on("change", 'body .m__glossary .m__glossary__select', function(e) { 
    $('.m__glossary #loading').addClass('active');
    $('.m__glossary .loading-background').addClass('active');
    var letter = $(this).val();
    $('.m__glossary .m__glossary__letter').removeClass('active');
    $(this).addClass('active');
    console.log(letter);
    e.preventDefault(); 

    var ajaxPromise = $.ajax({
        type: 'POST',
        url: mw_glossary_ajax_object.ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_glossary',
            'letter': letter,
            'security': mw_glossary_ajax_object.nonce,
        }),
        success: function (data) {
            result = data.html; 
        }
    });
    $.when(ajaxPromise).done(function () {
        $('.m__glossary__wrapper__contain').html(result);
        $('#loading').removeClass('active'); 
        $('.m__glossary .loading-background').removeClass('active');
    });
});